export const HubSpotSynchronizationTypeMap: Record<string, string> = {
  IMPORT_LOCATION_PROPERTY: 'Import Location Property',
  IMPORT_COMPANIES: 'Import Companies',
  IMPORT_CONTACTS: 'Import Contacts',
  IMPORT_SERVICE_TYPE_PROPERTY: 'Import Service Type Property',
  IMPORT_VEHICLE_PROPERTY: 'Import Vehicle Property',
  IMPORT_DEALS: 'Import Deals',
  CUSTOMER_TO_COMPANY: 'Create Company',
  CONTACT_TO_CONTACT: 'Create Contact',
  BOOKING_TO_DEAL: 'Create Deal',
  MARK_DEAL_AS_LOST: 'Mark Deal as Lost',
  BOOKED_QUOTE: 'Mark Deal as Won',
  UPDATE_DEAL: 'Update Deal',
  DELETE_DEAL: 'Delete Deal',
  UPDATE_CONTACT: 'Update Contact',
  UPDATE_COMPANY: 'Update Company',
}
